// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var ReportDownload$ReactHooksTemplate = require("../surveys/ReportDownload.res.js");

function DownloadList(props) {
  var match = React.useState(function (param) {
        return /* [] */0;
      });
  var setState = match[1];
  var match$1 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  React.useEffect((function (param) {
          Js_promise.then_((function (report_downloads) {
                  return Promise.resolve(Curry._1(setState, (function (param) {
                                    return report_downloads;
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/tickets/downloads", (function (param) {
                      return Json_decode.field("downloads", (function (param) {
                                    return Json_decode.list(ReportDownload$ReactHooksTemplate.decode, param);
                                  }), param);
                    })));
        }), []);
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(Curry._1(match$1[0], "ShowReport") ? JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("h2", {
                                        children: "Downloads",
                                        className: "text-xl font-semibold"
                                      }),
                                  className: "flex items-center p-20-px"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("table", {
                                        children: [
                                          JsxRuntime.jsx("thead", {
                                                children: JsxRuntime.jsxs("tr", {
                                                      children: [
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      "File",
                                                                      JsxRuntime.jsx("img", {
                                                                            className: "ml-4-px",
                                                                            src: Image$ReactHooksTemplate.heading
                                                                          })
                                                                    ],
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-2"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      "Status",
                                                                      JsxRuntime.jsx("img", {
                                                                            className: "ml-4-px",
                                                                            src: Image$ReactHooksTemplate.heading
                                                                          })
                                                                    ],
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-2"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      "Created At",
                                                                      JsxRuntime.jsx("img", {
                                                                            className: "ml-4-px",
                                                                            src: Image$ReactHooksTemplate.heading
                                                                          })
                                                                    ],
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-2"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsx("div", {
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-2"
                                                            })
                                                      ]
                                                    }),
                                                className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                              }),
                                          JsxRuntime.jsx("tbody", {
                                                children: $$Array.of_list(List.map((function (report_download) {
                                                            var rid = ReportDownload$ReactHooksTemplate.id(report_download);
                                                            var origin = window.location.origin;
                                                            var downloadUrl = origin + "/api/v1/report_downloads/" + String(rid) + "/download";
                                                            var match = ReportDownload$ReactHooksTemplate.status(report_download);
                                                            var tmp;
                                                            switch (match) {
                                                              case "Queued" :
                                                              case "InProgress" :
                                                                  tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
                                                                  break;
                                                              case "Done" :
                                                                  tmp = JsxRuntime.jsx("a", {
                                                                        children: JsxRuntime.jsx("img", {
                                                                              className: "h-16-px",
                                                                              src: Image$ReactHooksTemplate.downloadButton
                                                                            }),
                                                                        href: downloadUrl
                                                                      });
                                                                  break;
                                                              
                                                            }
                                                            return JsxRuntime.jsxs("tr", {
                                                                        children: [
                                                                          JsxRuntime.jsx("td", {
                                                                                children: ReportDownload$ReactHooksTemplate.name(report_download),
                                                                                className: "px-4 py-2"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: ReportDownload$ReactHooksTemplate.Status.toString(ReportDownload$ReactHooksTemplate.status(report_download)),
                                                                                className: "px-4 py-2"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: ReportDownload$ReactHooksTemplate.createdAt(report_download).fromNow(false),
                                                                                className: "px-4 py-2"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: tmp,
                                                                                className: "px-4 py-2"
                                                                              })
                                                                        ],
                                                                        className: "border-b border-bottom-gray-600"
                                                                      }, String(ReportDownload$ReactHooksTemplate.id(report_download)));
                                                          }), match[0]))
                                              })
                                        ],
                                        className: "text-left table-auto w-full border-separate text-xs font-medium"
                                      }),
                                  className: "flex px-20-px"
                                })
                          ]
                        }) : JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                                img: Caml_option.some(Image$ReactHooksTemplate.unAuthorized),
                                text: "401: Unauthorized!!",
                                loading: false
                              }),
                          className: "h-screen w-full animated fadeIn"
                        }))
            });
}

var emptyState = /* [] */0;

var make = DownloadList;

exports.emptyState = emptyState;
exports.make = make;
/* react Not a pure module */
